const DATABASENAME = "@liberacao-de-senha";

// const BASENAME = `/versao-beta`
const BASENAME = ``

const ROTA_INICIO = "/";

const ROTA_LOGIN = "/entrar";

const LISTA_DE_FILTROS_UTILIZADOS = `${DATABASENAME}:lista-de-filtros-utilizados`;

const HABILITADO_EXCLUSAO_MULTIPLAS_SOLICITACOES = `${DATABASENAME}:habilitado-exclusao-multiplas-solicitacoes`

const ELEMENTO_PARA_FOCO = `${DATABASENAME}:elemento-para-foco`;

const LIMITE = 50;

const BASE_URL_API =  "http://192.168.1.173:3337/api/solicitacaosenhaweb/"
const BASE_URL_API_PROD = "https://apiliberacaodesenha.radinfo.com.br/api/solicitacaosenhaweb/"
// const BASE_URL_API_PROD = "https://apiliberacaodesenha.radinfo.com.br/versao-beta/api/solicitacaosenhaweb/"

export const configs = {
    HABILITADO_EXCLUSAO_MULTIPLAS_SOLICITACOES,
    LISTA_DE_FILTROS_UTILIZADOS,
    ELEMENTO_PARA_FOCO,
    BASE_URL_API,
    BASE_URL_API_PROD,
    LIMITE,
    BASENAME,
    ROTA_INICIO,
    ROTA_LOGIN
};